import {API} from '../../api/API';
import { PROFILE_URL } from '../../config/config';

export const getProfile = () => {
    return API.get(PROFILE_URL);
}

export const saveProfile = async (profile) => {
    let response = await API.put(PROFILE_URL, profile);
    return response.data;
}

